import { Checkbox} from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useMemo, useState } from 'react';
import { updateVendorDetails } from 'modules/authorizations/store/actions/dataManagement.actions';
import { UPDATE_VENDOR_DETAILS_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { COLOR_PRIMARY, COLOR_SECONDARY } from 'styles/theme';



const VendorDetailsCard = props => {
  const theme = createTheme({
    palette: {
      primary: {
        main: COLOR_PRIMARY.main,
      },
      secondary: {
        main: COLOR_SECONDARY.main,
      },
    },
  });

  const [isLoading, setIsLoading] = useState(false);

  const { vendorDetails, vendorAddress, vendorDesignations, isReadOnly, enumerations, history } = props;

  const vendorTypes =
    enumerations && enumerations.vendorTypes && enumerations.vendorTypes.length > 0
      ? enumerations.vendorTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const countries =
    enumerations && enumerations.countries && enumerations.countries.length > 0
      ? enumerations.countries.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const provinces =
    enumerations && enumerations.provinces && enumerations.provinces.length > 0
      ? enumerations.provinces.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const designationsTypes =
    enumerations && enumerations.vendorDesignations && enumerations.vendorDesignations.length > 0
      ? enumerations.vendorDesignations.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const currentSelectedDesignations = useMemo(() => {
    if (vendorDesignations) {
      return designationsTypes
        .filter(f => vendorDesignations.some(x => x.vendorDesignationId === f.id))
        .map(f => ({ id: f.id, title: f.title }));
    }
    return [];
  }, [vendorDesignations, designationsTypes]);

  const tabs = [{ header: 'Partner Details', order: 1, iconPath: ['fas', 'file-contract'] }];

  const summaries = [
    {
      header: 'Company Name',
      accessorKey: 'companyName',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.companyName : null,
      hideInTable: true,
      tab: 1
    },
    {
      header: 'Partner Type',
      accessorKey: 'vendorTypeId',
      type: 'dropdown-v2',
      required: false,
      value: vendorDetails ? vendorDetails.vendorTypeId : false,
      options: vendorTypes,
      hideInTable: true,
      tab: 1
    },
    {
      header: 'Status',
      accessorKey: 'statusId',
      type: 'text',
      required: false,
      value: vendorDetails && enumerations ? enumerations.vendorStatuses.find(status => status.id === vendorDetails.statusId)?.title : '',
      disabled: true,
      hideInTable: true,
      tab: 1
    },
    {
      header: 'Contract Date',
      accessorKey: 'contractDate',
      type: 'date',
      required: false,
      value: vendorDetails ? vendorDetails.contractDate : '',
      hideInTable: true,
      tab: 1
    },
    {
      header: 'Contract Expires',
      accessorKey: 'contractExpires',
      type: 'date',
      required: false,
      value: vendorDetails ? vendorDetails.contractExpires : '',
      hideInTable: true,
      tab: 1
    },
    {
      header: 'Status Updated',
      accessorKey: 'statusUpdated',
      type: 'date',
      required: false,
      value: vendorDetails ? vendorDetails.statusUpdated : '',
      hideInTable: true,
      disabled: true,
      tab: 1
    },

    {
      header: 'Description',
      accessorKey: 'description',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.description : null,
      tab: 1
    },
    {
      header: 'Partner Code',
      accessorKey: 'vendorCode',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.vendorCode : '',
      tab: 1
    },
    {
      header: 'Office Email',
      accessorKey: 'officeEmail',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.officeEmail : '',
      tab: 1
    },
    {
      header: 'Office Phone',
      accessorKey: 'officePhone',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.officePhone : '',
      tab: 1
    },
    {
      header: 'Company Website',
      accessorKey: 'companyWebsite',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.companyWebsite : '',
      tab: 1
    },
    { header: 'SLA Ref', accessorKey: 'slaRelief', type: 'text', required: false, value: vendorDetails ? vendorDetails.slaRelief : '', tab: 1 },
    {
      header: 'Designations',
      accessorKey: 'designations',
      type: 'multi-select-v2',
      options: designationsTypes,
      required: false,
      value: currentSelectedDesignations,
      tab: 1
    },
    {
      header: 'Commissions',
      accessorKey: 'commissions',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.commissions : '',
      tab: 1
    },
    {
      header: 'Banking Info Required',
      accessorKey: 'hasBankingInformationRequired',
      type: 'checkbox',
      required: false,
      value: vendorDetails ? vendorDetails.hasBankingInformationRequired : false,
      hideInTable: true,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasBankingInformationRequired" label="Active" checked={cell.row.original.hasBankingInformationRequired} />
    },
    {
      header: 'Address',
      accessorKey: 'editedAddress',
      type: 'googleAddressSearch',
      required: false,
      value: vendorAddress ? vendorAddress : '',
      displayValue: vendorAddress ? vendorAddress.addressLine1 : '',
      tab: 1,
      provinces: provinces,
      countries: countries
    }
  ];

  if(vendorDetails.clientRecordId && vendorDetails.clientRecordId > 0){
    summaries.push({
      header: 'Client Record',
      accessorKey: 'clientRecordId',
      type: 'text',
      required: false,
      value: vendorDetails ? vendorDetails.clientLegalName : '',
      tab: 1,
      disabled: true,
      hideInModal: true,
      onClickNavigation: () => history.push(`/clients/${vendorDetails?.clientRecordId}`),
    });
  }
  
  const updateFields = async (tab, values) => {
    setIsLoading(true);

    const basicAuthInfo = {
      vendorRecord: { ...vendorDetails },
      address: {
        ...vendorAddress,
        addressLine1: values.editedAddress.addressLine1,
        city: values.editedAddress.city,
        county: values.editedAddress.county,
        countryId: values.editedAddress.countryId,
        provinceId: values.editedAddress.provinceId,
        zipcode: values.editedAddress.zipcode
      },
      designations: { ...vendorDesignations }
    }

    basicAuthInfo.vendorRecord.companyName = values.companyName;
    basicAuthInfo.vendorRecord.vendorTypeId = values.vendorTypeId;
    basicAuthInfo.vendorRecord.contractDate = values.contractDate;
    basicAuthInfo.vendorRecord.contractExpires = values.contractExpires;
    basicAuthInfo.vendorRecord.description = values.description;
    basicAuthInfo.vendorRecord.vendorCode = values.vendorCode;
    basicAuthInfo.vendorRecord.officePhone = values.officePhone;
    basicAuthInfo.vendorRecord.officeEmail = values.officeEmail;
    basicAuthInfo.vendorRecord.companyWebsite = values.companyWebsite;
    basicAuthInfo.vendorRecord.slaRelief = values.slaRelief;
    basicAuthInfo.vendorRecord.commissions = values.commissions;
    basicAuthInfo.vendorRecord.hasBankingInformationRequired = values.hasBankingInformationRequired;

    const designationIds = Array.isArray(values.designations) ? values.designations.map(s => s.id) : [];

    basicAuthInfo.designations = designationIds.map(id => ({ vendorDesignationId: id }));

    const resp = await props.updateVendorDetails(basicAuthInfo);
    if (resp.type === UPDATE_VENDOR_DETAILS_FAILURE) {
      props.showToast('Failed to update vendor details, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <EditableCard
        tabs={tabs}
        summaries={summaries}
        numColumns={5}
        updateFields={updateFields}
        isLoading={isLoading}
        hideEdit={isReadOnly}
      />
    </ThemeProvider>
  );
};

export default compose(
  connect(null, {
    updateVendorDetails,
    showToast
  })
)(VendorDetailsCard);
